import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ColorSwatchOption from './ColorSwatchOption';
import * as Styled from '../ColorSwatch.styles';

var ColorSwatchOptionWrap = function ColorSwatchOptionWrap(_ref) {
  var swatchAnchorLink = _ref.swatchAnchorLink,
      partNumber = _ref.partNumber,
      customUrl = _ref.customUrl,
      children = _ref.children;
  var productUrl = customUrl || "/product/".concat(partNumber);
  return swatchAnchorLink ? /*#__PURE__*/React.createElement("a", {
    href: "".concat(productUrl, "?clickOrigin=colourSwatch"),
    "data-test": "swatch-link-".concat(partNumber)
  }, children) : children;
};

var ColorSwatchList = function ColorSwatchList(_ref2) {
  var _colors$slice;

  var colors = _ref2.colors,
      selected = _ref2.selected,
      maxVariations = _ref2.maxVariations,
      enableShowMore = _ref2.enableShowMore,
      showMoreCallback = _ref2.showMoreCallback,
      disabled = _ref2.disabled,
      promptText = _ref2.promptText,
      swatchAnchorLink = _ref2.swatchAnchorLink,
      selectVariant = _ref2.selectVariant,
      size = _ref2.size,
      isFixed = _ref2.isFixed,
      isFabricSwatches = _ref2.isFabricSwatches,
      className = _ref2.className,
      dataTest = _ref2['data-test'];
  var colorVariants = isFabricSwatches ? colors === null || colors === void 0 ? void 0 : colors.slice(0, maxVariations).map(function (fabricVariant) {
    return _objectSpread(_objectSpread({}, fabricVariant), {}, {
      variantTitle: "".concat(fabricVariant.variantLabel, " ").concat(fabricVariant.variantFabric)
    });
  }) : colors;
  var fabricSwatchRemainder = colors === null || colors === void 0 ? void 0 : (_colors$slice = colors.slice(maxVariations)) === null || _colors$slice === void 0 ? void 0 : _colors$slice.length;

  var _useState = useState(selected),
      _useState2 = _slicedToArray(_useState, 2),
      selectedColor = _useState2[0],
      setSelectedColor = _useState2[1];

  var disabledClasses = disabled.map(function (isDisabled) {
    return isDisabled ? 'color-disabled' : '';
  });
  useEffect(function () {
    setSelectedColor(selected);
  }, [selected]);

  var handleClick = function handleClick(event, colorIndex) {
    event.preventDefault(); // need when <li> is nested within <a> i.e. @argos/product-card

    setSelectedColor(colorIndex);
    selectVariant(colorIndex);
  };

  var handleKeyDown = function handleKeyDown(event, colorIndex) {
    if (event.key === ' ' || event.key === 'Enter' || event.key === 'Spacebar') {
      handleClick(event, colorIndex);
    }
  };

  var generateListWithEnableShowMore = function generateListWithEnableShowMore() {
    // The following code generates an alternate list with a "show more" icon, as per the habitat design
    // https://www.figma.com/proto/4EYBqpOqrDzd8GJmpnUq6K/E2E-journey?node-id=1007%3A18241&viewport=191%2C166%2C0.09463819861412048&scaling=min-zoom&hide-ui=1
    return /*#__PURE__*/React.createElement("ul", {
      "data-test": "".concat(dataTest, "-list")
    }, colorVariants.map(function (color, index) {
      return index < maxVariations && /*#__PURE__*/React.createElement(Styled.ColorSwatchListLi, {
        "data-test": "".concat(dataTest, "-").concat(color, "-container"),
        disabled: disabledClasses[index],
        size: size,
        key: "color-".concat(index),
        title: color.variantTitle || color.variantLabel || color,
        onKeyDown: function onKeyDown(event) {
          return !swatchAnchorLink && !disabledClasses[index] && handleKeyDown(event, index);
        },
        onClick: function onClick(event) {
          return !swatchAnchorLink && handleClick(event, index);
        }
      }, /*#__PURE__*/React.createElement(ColorSwatchOptionWrap, {
        "data-test": "".concat(dataTest, "-").concat(color),
        swatchAnchorLink: swatchAnchorLink,
        partNumber: color.partNumber,
        customUrl: color.customUrl
      }, /*#__PURE__*/React.createElement(ColorSwatchOption, {
        enableShowMore: enableShowMore,
        color: color.variantLabel || color,
        hideLabel: true,
        selected: index === selectedColor,
        size: size,
        swatchAnchorLink: swatchAnchorLink
      })));
    }), /*#__PURE__*/React.createElement(Styled.ColorSwatchListLi, {
      size: size,
      onKeyDown: function onKeyDown(event) {
        return showMoreCallback(event);
      },
      onClick: function onClick(event) {
        return showMoreCallback(event);
      }
    }, /*#__PURE__*/React.createElement(Styled.ShowMorePlusIcon, {
      "data-test": "".concat(dataTest, "-show-more")
    })));
  };

  return /*#__PURE__*/React.createElement(Styled.ColorSwatchList, {
    isFixed: isFixed,
    $isFabricSwatches: isFabricSwatches,
    showPrompt: promptText,
    className: className,
    "data-test": dataTest
  }, colorVariants.length > 1 && promptText && /*#__PURE__*/React.createElement("div", {
    className: "prompt xs-hidden md-block"
  }, promptText), colorVariants.length > 1 && !enableShowMore && !isFabricSwatches && /*#__PURE__*/React.createElement(Styled.ColorSwatchListSummary, {
    isFixed: isFixed && colorVariants.length <= maxVariations,
    className: "".concat(colorVariants.length <= maxVariations ? 'md-hidden' : '')
  }, /*#__PURE__*/React.createElement(ColorSwatchOption, {
    "data-test": "".concat(dataTest, "-availableColours"),
    color: "multi",
    altLabel: "".concat(colorVariants.length, " Colours available")
  })), enableShowMore && !isFabricSwatches && generateListWithEnableShowMore(), colorVariants.length <= maxVariations && /*#__PURE__*/React.createElement("ul", {
    "data-test": "".concat(dataTest, "-list")
  }, colorVariants.map(function (color, index) {
    return /*#__PURE__*/React.createElement(Styled.ColorSwatchListLi, {
      "data-test": "".concat(dataTest, "-").concat(color, "-container"),
      disabled: disabledClasses[index],
      $isFabricSwatches: isFabricSwatches,
      size: size,
      key: "color-".concat(index),
      title: color.variantTitle || color.variantLabel || color,
      onKeyDown: function onKeyDown(event) {
        return !swatchAnchorLink && !disabledClasses[index] && handleKeyDown(event, index);
      },
      onClick: function onClick(event) {
        return !swatchAnchorLink && handleClick(event, index);
      }
    }, /*#__PURE__*/React.createElement(ColorSwatchOptionWrap, {
      "data-test": "".concat(dataTest, "-").concat(color),
      swatchAnchorLink: swatchAnchorLink,
      partNumber: color.partNumber,
      customUrl: color.customUrl
    }, /*#__PURE__*/React.createElement(ColorSwatchOption, {
      enableShowMore: enableShowMore,
      color: color.variantLabel || color,
      fabric: color.variantFabric,
      isFabricSwatches: isFabricSwatches,
      hideLabel: true,
      selected: index === selectedColor,
      size: size,
      swatchAnchorLink: swatchAnchorLink
    })));
  }), isFabricSwatches && fabricSwatchRemainder > 0 && /*#__PURE__*/React.createElement("li", {
    "aria-label": "".concat(fabricSwatchRemainder, " more fabric and colour options available"),
    "data-test": "".concat(dataTest, "-swatch-remainder")
  }, "+", fabricSwatchRemainder)));
};

var colorShape = {
  /**
   * Description of variant colour
   */
  variantTitle: PropTypes.string,

  /**
   * Description of variant colour
   */
  variantLabel: PropTypes.string,

  /**
   * Optional prop for the variant fabric (for fabric swatches)
   */
  variantFabric: PropTypes.string,

  /**
   * Product code of variant
   */
  partNumber: PropTypes.string,

  /**
   * Product URL (will override the default from this component)
   */
  customUrl: PropTypes.string
};
ColorSwatchList.propTypes = {
  /**
   * Specify list of colors
   */
  colors: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape(colorShape)])).isRequired,

  /**
   * Optional prop to specify the selected color
   */
  selected: PropTypes.number,

  /**
   * Optional prop to specify the max amount of colors to show. If the amount of colors is above the max a prompt will be show.
   */
  maxVariations: PropTypes.number,

  /**
   * Optional prop to choose whether or not to display the + icon rather than text when color list is greater than maxVariations
   */
  enableShowMore: PropTypes.bool,

  /**
   * Optional prop for an onClick callback func if enableShowMore is passed
   */
  showMoreCallback: PropTypes.func,

  /**
   * Optional prop to specify the disabled colors
   */
  disabled: PropTypes.arrayOf(PropTypes.bool),

  /**
   * Optional prop to specify and show the prompt label
   */
  promptText: PropTypes.string,

  /**
   * Optional prop to wrap the color with <a> to redirect to new a product
   */
  swatchAnchorLink: PropTypes.bool,

  /**
   * Optional prop for an onClick callback func if swatchAnchorLink is false
   */
  selectVariant: PropTypes.func,

  /**
   * Optional prop to don't hide in small screens
   */
  isFixed: PropTypes.bool,

  /**
   * Optional prop to display variants as fabric swatch tiles. Requires variantFabric in the color object
   */
  isFabricSwatches: PropTypes.bool,

  /**
   * Optional prop to change size of the circle (small, medium)
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Specify an optional className to be added to your Alert
   */
  className: PropTypes.string,

  /**
   * Specify an optional data-test attribute to be added for e2e testing
   */
  'data-test': PropTypes.string
};
ColorSwatchList.defaultProps = {
  maxVariations: 5,
  enableShowMore: false,
  showMoreCallback: function showMoreCallback() {},
  disabled: [],
  swatchAnchorLink: false,
  selectVariant: function selectVariant() {},
  size: 'small',
  isFixed: false,
  isFabricSwatches: false,
  'data-test': 'component-color-swatch'
};
export default ColorSwatchList;